import {
    FETCH_KNOWI_CREDENTIALS
} from '../actions/actionTypes';

const initialState = {
    sessionToken: '',
    timestamp:    '',
    user:         '',
    userToken:    ''
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_KNOWI_CREDENTIALS:
            return {
                ...state,
                sessionToken: action.payload.sessionToken,
                timestamp:    action.payload.timestamp,
                user:         action.payload.user,
                userToken:    action.payload.userToken
            };
        default:
            return state;
    }
};
